import { render, staticRenderFns } from "./VUserSignup.vue?vue&type=template&id=1fea427e&"
import script from "./VUserSignup.vue?vue&type=script&lang=js&"
export * from "./VUserSignup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports